import React, { Component } from 'react'
import styles from './Summary.css'
import {formatDecimal} from 'utils/formatter'

class Summary extends Component {

  render () {
    let {nonLoyaltyMemberTotal, loyaltyMemberTotal, rewardsTotal} = this.props
    return (
      <div className={`col-md-12 ${styles['summary']}`}>
        <div className='row'>
          <div style={{ padding: '25px 0px 25px 0px' }} className='col-md-4 col-sm-4 text-center'>
            <div className={`col-md-12 col-sm-12 ${styles.total}`}>
              {formatDecimal(nonLoyaltyMemberTotal)}
            </div>
            <div className={`col-md-12 col-sm-12 ${styles.title}`}>
              NON-LOYALTY MEMBER
            </div>
          </div>
          <div style={{ padding: '25px 0px 25px 0px' }} className='col-md-4 col-sm-4 text-center'>
            <div className={`col-md-12 col-sm-12 ${styles.total}`}>
              {formatDecimal(loyaltyMemberTotal)}
            </div>
            <div className={`col-md-12 col-sm-12 ${styles.title}`}>
              LOYALTY MEMBER
            </div>
          </div>
          <div style={{ padding: '25px 0px 25px 0px' }} className='col-md-4 col-sm-4 text-center'>
            <div className={`col-md-12 col-sm-12 ${styles.total}`}>
              {formatDecimal(rewardsTotal)}
            </div>
            <div className={`col-md-12 col-sm-12 ${styles.title}`}>
              REWARDS REDEEMED
            </div>
          </div>
        </div>
      </div>
    )
  }

}

Summary.propTypes = {
  nonLoyaltyMemberTotal: React.PropTypes.number,
  loyaltyMemberTotal: React.PropTypes.number,
  rewardsTotal: React.PropTypes.number
}

export default Summary



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListLoyalty/Summary/Summary.js